module.exports = "/img/auto-lease-calculator-banner.f0332a60.png";